import PackageRepository from "../domain/data/PackageRepository";
import Package from "../domain/entities/Package";
import User from "../domain/entities/User";
import AwsApiClient from "../presentation/hooks/AwsApiClient";

export default class APIPackageRepository implements PackageRepository {
  private client = new AwsApiClient();

  async savePackage(user: User, packageData: Package): Promise<Package> {
    try {
      const response = await this.client.post(`/api/package`, packageData);
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }

  async deletePackage(user: User, objPackage: Package): Promise<boolean> {
    try {
      const response = await this.client.delete(
        `/api/package/${user.organization.id}/${user.id}/${objPackage.id}`, "none"
      );
      return true;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }

  async getPackages(user: User): Promise<Package[]> {
    try {
      const response = await this.client.get(`/api/package/${user.organization.id}/${user.id}`);
      const packages = Array.isArray(response) ? response : [];
      return packages.map((pkg: any) => {
        const legacySingleTemplate = pkg?.documentTemplate
          ? [pkg.documentTemplate]
          : [];
        const normalizedTemplates = Array.isArray(pkg?.documentTemplates)
          ? pkg.documentTemplates.filter(Boolean)
          : legacySingleTemplate;

        return {
          ...pkg,
          description: pkg?.description ?? "",
          documentTemplates: normalizedTemplates,
          shared: !!pkg?.shared,
        } as Package;
      });
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }
}
